export const MENU_HEIGHT = 106;
export const MENU_HEIGHT_MOBILE = 86;

export const FILTERS_HEIGHT_DESKTOP = 74;
export const FILTERS_HEIGHT_TABLET = 136;
export const FILTERS_HEIGHT_MOBILE = 186;

export const SEARCH_FILTERS_TOP_OFFSET = 300;
